export const NAME = 'mailingOperations';